import cn from 'classnames';
import React from 'react';

import ExternalLink from '@/common/components/atoms/ExternalLink/ExternalLink';
import NavLinkExtended from '@/common/components/blocks/NavLinkExtended/NavLinkExtended';

import CONFIG from './config';
import {
  LinkLikeButtonDefaultProps,
  LinkLikeButtonPropTypes,
} from './LinkLikeButton.proptypes';

const LinkLikeButton = ({
  buttonSize,
  children,
  className,
  context,
  disabled,
  display,
  external,
  onClick,
  url,
  variant,
}) => {
  if (external) {
    return (
      <ExternalLink
        className={cn(CONFIG.css.class, className, {
          [`${CONFIG.css.class}--button-size-${buttonSize}`]: buttonSize,
          [`${CONFIG.css.class}--disabled`]: disabled,
          [`${CONFIG.css.class}--display-${display}`]: display,
          [`${CONFIG.css.class}--variant-${variant}`]: variant,
        })}
        disabled={disabled}
        href={url}
        data-qa-id={`${context || 'external-link'}-${
          disabled ? 'disabled' : 'active'
        }`}
      >
        {children}
      </ExternalLink>
    );
  }

  return (
    <NavLinkExtended
      className={cn(CONFIG.css.class, className, {
        [`${CONFIG.css.class}--button-size-${buttonSize}`]: buttonSize,
        [`${CONFIG.css.class}--disabled`]: disabled,
        [`${CONFIG.css.class}--display-${display}`]: display,
        [`${CONFIG.css.class}--variant-${variant}`]: variant,
      })}
      context={context}
      disabled={disabled}
      onClick={onClick}
      to={url}
    >
      {children}
    </NavLinkExtended>
  );
};

LinkLikeButton.defaultProps = {
  ...LinkLikeButtonDefaultProps,
};

LinkLikeButton.propTypes = {
  ...LinkLikeButtonPropTypes,
};

export default LinkLikeButton;
